// components/use-case-details/use-case-workflow/workflowStoryPlayback.ts

export function initialPlayedOnce(autoPlay: boolean): boolean {
  return autoPlay;
}

export function playedOnceAfterPlayAction(wasPlaying: boolean): boolean {
  return !wasPlaying ? true : true;
}
